import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* fetchDealerConfigurationCheck() {
  try {
    const config = yield call(function() {
      return Api.get('/dealer/configuration-check')
    });
    yield put({type: 'FETCH.DEALER_CONFIGURATION_CHECK.SUCCESS', config});
  } catch (error) {
    yield put({type: 'FETCH.DEALER_CONFIGURATION_CHECK.FAILURE', error});
  }
}

export function* watchFetchDealerConfigurationCheck() {
  yield takeEvery('FETCH.DEALER_CONFIGURATION_CHECK.REQUEST', fetchDealerConfigurationCheck)
}
